"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.normalizedDateFormatMobile = exports.normalizedDateFormat = void 0;
exports.normalizedDateFormat = 'YYYY-MM-DD';
// Emulate Mobile bug https://clinicalink.atlassian.net/browse/OR-18939?focusedCommentId=182857
exports.normalizedDateFormatMobile = 'YYYY-MM-DD HH:mm:ss';
